import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RecurringFeeQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
}>;

export type RecurringFeeQuery = {
  __typename?: "Query";
  recurringFee?: {
    __typename?: "RecurringFee";
    id: string;
    serviceName: Types.TaxServiceName;
    customLabel?: string | null;
    customDescription?: string | null;
    amountInCents: number;
    rhythmInMonths: number;
    billingDay: number;
    anchorMonth: number;
    validFrom: string;
    validUntil?: string | null;
    includeInExport: boolean;
    billedThroughMonth?: string | null;
    hasGeneratedRows: boolean;
    updatedAt: string;
  } | null;
};

export const RecurringFeeDocument = gql`
  query recurringFee($email: String!) {
    recurringFee(email: $email) {
      id
      serviceName
      customLabel
      customDescription
      amountInCents
      rhythmInMonths
      billingDay
      anchorMonth
      validFrom
      validUntil
      includeInExport
      billedThroughMonth
      hasGeneratedRows
      updatedAt
    }
  }
`;

/**
 * __useRecurringFeeQuery__
 *
 * To run a query within a React component, call `useRecurringFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringFeeQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRecurringFeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecurringFeeQuery,
    RecurringFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecurringFeeQuery, RecurringFeeQueryVariables>(
    RecurringFeeDocument,
    options
  );
}
export function useRecurringFeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecurringFeeQuery,
    RecurringFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecurringFeeQuery, RecurringFeeQueryVariables>(
    RecurringFeeDocument,
    options
  );
}
export type RecurringFeeQueryHookResult = ReturnType<
  typeof useRecurringFeeQuery
>;
export type RecurringFeeLazyQueryHookResult = ReturnType<
  typeof useRecurringFeeLazyQuery
>;
export type RecurringFeeQueryResult = Apollo.QueryResult<
  RecurringFeeQuery,
  RecurringFeeQueryVariables
>;
